import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ConfettiService, EventService, ScApiService } from '@sc-ui';
import { LocalizationService } from 'src/services/localization.service';
import { NotificationsService } from 'src/services/notifications.service';
import { UserService } from 'src/services/user.service';
import { NotificationsModalComponent } from '../notifications-modal/notifications-modal.component';
import { texts } from './sidebar.texts';
import { DemoService } from 'src/services/demo.service';

@Component({
  standalone: false,
  selector: 'app-sidebar',
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.scss',
})
export class Sidebar implements OnInit {

  texts = texts;

  // the version shown under the logo is the current month
  today = new Date();

  projectCount = 1;

  preparedProjectCount = 0;

  analysisRequestedCount = 0;

  // the status links only differ in their query param, so the default (subset)
  // matching would mark all of them active on /projects
  statusLinkOptions = {
    paths: 'exact' as const,
    queryParams: 'exact' as const,
    matrixParams: 'ignored' as const,
    fragment: 'ignored' as const
  };

  @ViewChild(NotificationsModalComponent)
  notificationsModal: NotificationsModalComponent;

  constructor(
    public notifications: NotificationsService,
    public userService: UserService,
    public loc: LocalizationService,
    private api: ScApiService,
    private events: EventService,
    private confetti: ConfettiService,
    private router: Router,
    public demo: DemoService
  ) { }

  ngOnInit() {

    this.notifications.load();

    this.events.channel('users/' + this.api.userId + '/ui').subscribe((e: any) => {
      if (e.Name == 'navigate') {
        var route = e.Payload.Route;
        this.router.navigateByUrl(route);
      }
      if (e.Name == 'confetti') {
        this.confetti.start(5);
      }
    });

    this.api.get('projects/count')
      .subscribe((p: any) => {
        this.projectCount = p.Total;
        this.preparedProjectCount = p.Prepared;
        this.analysisRequestedCount = p.AnalysisRequested;
      });

  }

  logout() {
    this.api.logout().subscribe();
    this.events.unsubscribeAll();
    this.router.navigateByUrl('/login');
  }

  navigateItem(i) {
    if (i.Candidate) {
      this.router.navigateByUrl('/projects/' + i.Project.Id + '/candidates/' + i.Candidate.Id);
      return;
    }

    if (i.Project) {
      this.router.navigateByUrl('/projects/' + i.Project.Id);
    }
  }

}
